// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-modal-overlay.revalidate-password-modal .react-modal {
  padding-top: 1rem;
  top: 15%;
  left: calc(50% - 16rem);
  width: 32rem;
  height: 35rem;
  height: -moz-fit-content;
  height: fit-content;
  box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);
  border-radius: 0.5rem;
}
.react-modal-overlay.revalidate-password-modal .logo-wrapper {
  text-align: center;
}
.react-modal-overlay.revalidate-password-modal .logo-wrapper img.logo {
  height: 5rem;
  margin-bottom: 2rem;
  margin-top: 2rem;
}
.react-modal-overlay.revalidate-password-modal .form-group.flex-row {
  flex-wrap: wrap;
}
.react-modal-overlay.revalidate-password-modal .form-group.flex-row label {
  flex: 1 1 100%;
}
.react-modal-overlay.revalidate-password-modal .submit-button {
  padding-top: 1rem;
  margin: 0 auto;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Components/RevalidatePassword/RevalidatePassword.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;EAAA,mBAAA;EAGA,sDAAA;EACA,qBAAA;AAAJ;AAGE;EACE,kBAAA;AADJ;AAEI;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;AAAN;AAIE;EACE,eAAA;AAFJ;AAII;EACE,cAAA;AAFN;AAME;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AAJJ","sourcesContent":[".react-modal-overlay.revalidate-password-modal {\n  .react-modal {\n    padding-top: 1rem;\n    top: 15%;\n    left: calc(50% - 16rem);\n    width: 32rem;\n    height: 35rem;\n    height: fit-content;\n    -webkit-box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n    -moz-box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n    box-shadow: 0.3rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.19);\n    border-radius: 0.5rem;\n  }\n\n  .logo-wrapper {\n    text-align: center;\n    img.logo {\n      height: 5rem;\n      margin-bottom: 2rem;\n      margin-top: 2rem;\n    }\n  }\n\n  .form-group.flex-row {\n    flex-wrap: wrap;\n\n    label {\n      flex: 1 1 100%;\n    }\n  }\n\n  .submit-button {\n    padding-top: 1rem;\n    margin: 0 auto;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
